import React, { useState } from 'react';
import { Desc, ExpertName, ExpertSec, ViewProfile } from './styled';
import { images } from '../../../Constants/ImageUrls';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { useRouter } from 'next/router';
import HeadingSEO from '../../../Utils/SEO/DescriptionSEO';
import { getScreenName } from '../../../Utils/helper';
import { fireEvent } from '../../../Utils/fireEvent';

export default function ExpertSection(props) {
  const { data, heading, showCreatedBy } = props;
  const expertId = data?.expertData?.user_id;
  const [clickEffect, setClickEffect] = useState(false);
  const router = useRouter();
  const clickHandler = (p1, url, p2, p3) => {
    setClickEffect(true);
    fireEvent({
      category: 'clicked_cta',
      cta: 'View profile',
      screen_name: getScreenName(),
      parent: 'Medically reviewed by',
    });
    setTimeout(() => {
      router.push(url);
      setClickEffect(false);
    }, 200);
  };
  return (
    <>
      {data?.expertData ? (
        <ExpertSec>
          <div className="expert_image_box">
            <img
              // loading="lazy"
              src="/images/expert_border.svg"
              alt=""
              className="expert_border"
            />
            <img
              //loading="lazy"
              src={`${data?.expertData?.image}?tr=w-62,q-80`}
              alt=""
              className="expert_image"
            />
            <img
              // loading="lazy"
              src="/images/expert_tick.svg"
              alt=""
              className="expert_tick"
            />
          </div>
          <div>
            <Desc as="p">{heading ? heading : `Verified Article by`}</Desc>

            <ExpertName as="p">{data?.expertData?.name}</ExpertName>
            <Desc as="p">
              {data?.expertData?.specialization} -{' '}
              {data?.expertData?.qualification.replace(',', '|')}
            </Desc>
            <AnchorCoverTag
              // url={
              //     expertId
              //         ? getPublicUrl() +
              //           "/clinic/expert-profile/" +
              //           expertId
              //         : null
              // }
              cardEffect={clickEffect ? 'lowOpacity' : ''}
              callbackFunction={clickHandler}
            >
              <ViewProfile>
                {' '}
                <p>View Profile</p> <img src={images.arrow_red_new} alt="" />
              </ViewProfile>
            </AnchorCoverTag>
          </div>
        </ExpertSec>
      ) : null}
      {data?.created_by && showCreatedBy ? (
        <ExpertSec>
          <div className="expert_image_box">
            <img
              loading="lazy"
              src={data?.user_details?.webpImages}
              alt=""
              className="expert_image"
            />
          </div>
          <div>
            <Desc as="p">Written by</Desc>
            <ExpertName as="p">
              {data?.user_details?.firstname +
                ' ' +
                data?.user_details?.lastname}
            </ExpertName>
            <HeadingSEO
              description={data?.user_details?.userbio}
              desktopClamp={4}
              desktopChartLimit={300}
              fontSize="12px"
              mobileCharLimit={120}
              author={true}
            ></HeadingSEO>
          </div>
        </ExpertSec>
      ) : null}
    </>
  );
}
